// extracted by mini-css-extract-plugin
export default {"header":"header_header__MTdzf","wrapper":"header_wrapper__Km15q","logo":"header_logo__6lRD2"};